import { Component } from "@angular/core";

@Component({
  selector: "app-redirect-page",
  standalone: true,
  template: "",
})
export class RedirectPageComponent {}
